import React from "react";
import Particles from "react-particles-js";
import { GiIndianPalace } from "react-icons/gi";
import { FiMail } from "react-icons/fi";
import { FaPhoneAlt, FaCopyright } from "react-icons/fa";
import { FcGlobe } from "react-icons/fc";

const Footer = () => {
  return (
    <div className="footer-wraper">
      <Particles
        params={{
          particles: {
            number: {
              value: 30,
            },
            size: {
              value: 2,
            },
          },
          interactivity: {
            events: {
              onhover: {
                enable: true,
                mode: "repulse",
              },
            },
          },
        }}
      />
      <div className="footer-headers">
        <div>
          <h1>Location </h1>
          <span className="d-flex align-items-center">
            <GiIndianPalace className="footer-logo" />
            <span className="footer-text">MH, India</span>
          </span>
        </div>
        <div>
          <h1>Contact</h1>
          <span className="d-flex align-items-center">
            <FiMail className="footer-logo" />
            <span className="footer-text">PrathameshSarode80@gmail.com</span>
          </span>
          <span className="d-flex align-items-center mt-2">
            <FaPhoneAlt className="footer-logo" />
            <span className="footer-text">+91 9699xxxxxx</span>
          </span>
        </div>
        <div>
          <h1>Website Info.</h1>
          <p className="d-flex align-items-center footer-text">
            {" "}
            <FcGlobe className="footer-logo" />
            For Frontend I Used React & Some NPM Packages :
          </p>
          <ul className="footer-ul">
            <li>react-elastic-carousel</li>
            <li>react-particles-js</li>
            <li>react-vertical-timeline-component</li>
          </ul>
        </div>
      </div>

      <div className="copyright">
        <h1 className="copy-logo">
          {" "}
          <FaCopyright /> 2021 - Prathamesh | All Rights Reserved | Privacy.
        </h1>
      </div>
    </div>
  );
};

export default Footer;
